<h2 class="text-center text-black text-xl mb-4 mt-2 text-balance">
  History Book
</h2>

<div class="flex flex-col mb-4 px-2">
  <mat-form-field appearance="outline" class="w-full">
    <mat-label>Search</mat-label>
    <input matInput [(ngModel)]="searchTerm" />
    <mat-icon matSuffix>search</mat-icon>
  </mat-form-field>

  <mat-menu #sortMenu="matMenu" class="min-w-[200px]">
    <button
      mat-menu-item
      (click)="setSortOrder('desc')"
      class="flex items-center gap-2"
    >
      <mat-icon>arrow_upward</mat-icon>
      <span>Oldest First</span>
    </button>
    <button
      mat-menu-item
      (click)="setSortOrder('asc')"
      class="flex items-center gap-2"
    >
      <mat-icon>arrow_downward</mat-icon>
      <span>Newest First</span>
    </button>
  </mat-menu>

  <button
    mat-raised-button
    color="primary"
    class="w-full"
    [matMenuTriggerFor]="sortMenu"
  >
    Sort by Date
    <mat-icon>expand_more</mat-icon>
  </button>
</div>

<div class="min-h-72 w-full max-h-72 h-full overflow-auto">
  <div class="space-y-4 rounded px-2">
    <mat-card
      *ngFor="let action of filteredActions"
      appearance="outlined"
      class="w-full !shadow-custom"
    >
      <mat-card-header class="border-b border-black border-opacity-12 !p-3">
        <mat-card-title class="text-black">{{ action.action }}</mat-card-title>
      </mat-card-header>
      <mat-card-content class="!p-3">
        <div class="flex flex-col gap-2">
          <div>
            <p class="text-sm font-medium text-muted-foreground">Date</p>
            <p class="text-black">{{ action.date }} {{ action.time }}</p>
          </div>
          <hr />
          <div>
            <p class="text-sm font-medium text-muted-foreground">Content</p>
            <mat-list>
              <div class="space-y-2">
                <mat-list-item
                  *ngFor="let item of contentParsed(action.content)"
                >
                  <p class="text-black" [title]="item.key">
                    {{ item.key }}
                  </p>
                  <p class="text-gray-600 text-sm pl-2" [title]="item.value">
                    {{ item.value }}
                  </p>
                </mat-list-item>
              </div>
            </mat-list>
          </div>
        </div>
      </mat-card-content>
    </mat-card>
  </div>
</div>
<div class="px-2 mt-4">
  <button
    mat-raised-button
    color="primary"
    (click)="downloadHistory()"
    class="w-full"
  >
    <mat-icon>download</mat-icon>
    Download History
  </button>
</div>
